import { render, staticRenderFns } from "./PageEdit.vue?vue&type=template&id=4b462a07&scoped=true&lang=pug&"
import script from "./PageEdit.vue?vue&type=script&lang=js&"
export * from "./PageEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b462a07",
  null
  
)

export default component.exports